function setReason (item)
{
	switch(item)
	{
		case "death_of_dog":
			return 'Loss of Pet';
		case "service":
			return 'Service Quality';
		case "moving":
			return 'Moving';
		case "competition":
			return 'Pricing';
		case "other":
			return 'Other';
	}
}

export const CancelationReportWrapper = (data) =>
{
	let result = [];

	if(data.results && data.results.length > 0)
	{
		data.results.forEach(element => {
			result.push({
				...element,
				cancelation_reason: setReason(element.cancelation_reason)
			});
		});
	}

	return {...data, result};
}